// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"9a14ed5b","455":"6eada46b","626":"4bb57ac7","977":"df14a0ef"}[chunkId] + ".chunk.js";
};